module.exports = __webpack_public_path__ + "app/admin/monitoring/monitoring-details-1Cs9LxXb.html";